import { Briefcase, CreditCard, FileText, GraduationCap, Inbox, LifeBuoy, Settings2, Sun } from "lucide-react";

// Sidebar sections grouped by daily work. Module keys and routes stay unchanged.
export const SECTIONS = [
  { key: "today", label: "Today", icon: Sun, tint: "gold", items: ["overview"] },
  { key: "leads", label: "Leads", icon: Inbox, tint: "blue", items: ["submissions", "contacts", "companies", "partners"] },
  { key: "sales", label: "Orders & payments", icon: CreditCard, tint: "green", items: ["orders", "paperwork"] },
  { key: "courses", label: "Courses", icon: GraduationCap, tint: "purple", items: ["course-library", "course-enrollments", "courses", "speakers"] },
  { key: "customers", label: "Customers & support", icon: LifeBuoy, tint: "teal", items: ["customers", "support", "grants", "grant-history"] },
  { key: "content", label: "Website content", icon: FileText, tint: "orange", folded: true,
    items: ["blogs", "services", "service-catalogue", "resources", "legacy-resources", "site-content", "media", "versions", "scans"] },
  { key: "recruiting", label: "Recruiting", icon: Briefcase, tint: "gray", folded: true, items: ["applications", "assessments"] },
  { key: "system", label: "System", icon: Settings2, tint: "gray", folded: true,
    items: ["sync", "mappings", "email", "exports", "audit", "privacy", "team", "invitations", "settings"] },
];

// Course delivery is opened from a course, so it lives under Courses without a menu entry.
export const sectionOf = (key) =>
  SECTIONS.find((s) => s.items.includes(key)) || (key === "course-delivery" ? SECTIONS[3] : null);

export const pathOf = (key) => (key === "overview" ? "/admin" : `/admin/${key}`);

// Short names for the in-page tabs (the menu shows only sections).
export const TAB_LABELS = {
  submissions: "Inbox", "course-library": "Library", "course-enrollments": "Enrollments", courses: "Featured", speakers: "Speakers",
  customers: "Customers", support: "Support", grants: "File access", "grant-history": "Access history",
  blogs: "Blog", services: "Service pages", "service-catalogue": "Catalogue", resources: "Resources", "legacy-resources": "Old resource pages",
  "site-content": "Site content", media: "Media", versions: "File versions", scans: "File checks",
  paperwork: "Paperwork editions", sync: "TMS sync", mappings: "TMS mappings", email: "Email", exports: "Exports", audit: "Audit trail",
  privacy: "Privacy", team: "Team", invitations: "Invitations", settings: "Settings",
};
